var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8812 0.790625L9.46562 2.20625L12.2969 5.0375L13.7125 3.62188C14.1 3.23125 14.1 2.59375 13.7125 2.20625L12.2969 0.790625C11.9062 0.403125 11.2687 0.403125 10.8812 0.790625ZM0 11.6719L8.75937 2.9125L11.5875 5.74062L2.82812 14.5H0V11.6719ZM1.41562 11.6719L2.12188 12.3781L9.46562 5.03438L8.75937 4.32812L1.41562 11.6719Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.63eece349e8169721969908c265b812e.svg";
export { ForwardRef as ReactComponent };